import { commonLang, lang, getCurrentSystem } from '@umu/ukit-lang';
import { $location, $window, getQueryString, isInIframe } from '@umu/umu-dom';
import { isFromAws, isFromCos } from '@umu/umu-image-handle';
import { sessionStorageHelper, STORAGE_KEY } from '@umu/umu-storage';
import { EOptionType, ESurveySectionType, ISurveySectionInfo, IUserInfo, SendMsgType } from '@umu/umu-types';
import * as ua from '@umu/umu-ua';
import { checkStringContainChineseOrJapanese, getData, Log, openWindow } from '@umu/umu-util';
import umuWebview from '@umu/umu-webview';
import { services } from 'common';
import { sendMsgToApp } from '../services/webview/sengMsgToApp';
import _get from 'lodash/get';
const { getModuleData, Toast } = services;

const log = new Log('umuUtil');

export { LANG } from './webview';

interface ITheme {
    id: number;
    title: string;
    type: number; // 1: 邀请卡 2：成就卡
    preview_url: string; // 缩略图
    background_url: string;
}

export function getEnterpriseId() {
    return getModuleData('userInfo', 'enterprise_info', 'enterprise_id') || '';
}

// 企业定制需求工具方法
// 企业要求快速注册浮层修改文案，跳转登录时带参数以修改登录页面展现，同时隐藏右上角注册入口
export function getEnterpriseEnrollInfo() {
    log.error('getEnterpriseEntorllInfo Error!');
    const enterpriseCustom = getModuleData('contextInfo', 'enterprise_info', 'config') || {};
    const isEnrollAutoRegisterEnterprise = getData(enterpriseCustom, 'enroll_auto_register_enterprise') === 1;

    let enterpriseId = '';
    let loginPageUrlParams = '';
    let enterpriseEnrollShowName = 'UMU';
    let hideRegisterEntry = false;
    let enterpriseLogo = '';

    if (isEnrollAutoRegisterEnterprise) {
        enterpriseId = getData(enterpriseCustom, 'enterprise_id');
        loginPageUrlParams = '&eid=' + enterpriseId;
        enterpriseEnrollShowName = getData(enterpriseCustom, 'enterprise_name') || enterpriseEnrollShowName;
        enterpriseLogo = getModuleData('contextInfo', 'enterprise_info', 'logo');
        hideRegisterEntry = true;
    }
    return {
        enterpriseId,
        loginPageUrlParams,
        enterpriseEnrollShowName,
        enterpriseLogo,
        hideRegisterEntry,
    };
}

export function getLoginUrl(): string {
    return '/globaluser/loginpage?from_url=' + encodeURIComponent($window.location.href);
}

export function gotoLogin() {
    $location.href = getLoginUrl();
}

export function gotoRegist() {
    const returnUrl = '?from_url=' + $location.href;
    $location.href = $location.origin + '/globaluser/registerpage#/index' + returnUrl;
}

// tslint:disable
export const base64Image = {
    BG_PLACEHOLDER: '',
    BLANK_16_9:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAApJREFUCNdjwA0AABsAAQrj5HwAAAAASUVORK5CYII=',
};

/**
 * 打乱数组顺序
 * @param {*} arr
 * return 被打算顺序的新数组
 */
export const shuffle = (arr: any[] = []) => {
    if (!(arr instanceof Array)) {
        return arr;
    }
    const newArr = arr.concat();
    for (let i = newArr.length - 1; i >= 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1));
        [newArr[i], newArr[randomIndex]] = [newArr[randomIndex], newArr[i]];
    }
    return newArr;
};

/**
 * 分享卡 - 打乱 themelist 顺序，但是根据type排优先级
 * @param {Array<ITheme>} 原始的 themeList
 * @return {Array<ITheme>} 排好序的 themeList
 */
export const getShuffleThemeList = (array: ITheme[]) => {
    const themeTypeMapArr: Array<{ type: number; list: ITheme[] }> = [];
    const len = array.length;
    let shuffleList = [];
    let resArr = null;
    const mapThemeToMapArr = (theme: ITheme) => {
        const themeType = theme.type;
        let hasFlag = false;
        for (let i = 0; i < themeTypeMapArr.length; i++) {
            const item = themeTypeMapArr[i];
            if (themeType === item.type) {
                item.list.push(theme);
                hasFlag = true;
            }
        }
        if (!hasFlag) {
            themeTypeMapArr.push({
                type: themeType,
                list: [theme],
            });
        }
    };
    for (let index = 0; index < len; index++) {
        const item = array[index];
        mapThemeToMapArr(item);
    }
    for (let i = 0; i < themeTypeMapArr.length; i++) {
        shuffleList = shuffle(themeTypeMapArr[i].list);
        if (resArr) {
            resArr = resArr.concat(shuffleList);
        } else {
            resArr = shuffleList;
        }
    }
    return resArr || [];
};

export const pinUrl = location.protocol + '//pin.' + location.host.replace(/^(test\.)?((www|m|pin)\.)?/, '');

export const getWindowParentUrl = () => {
    let url = '';
    if (parent !== $window) {
        try {
            url = parent.location.href;
        } catch (e) {
            url = document.referrer;
        }
    }
    return url;
};

// 检查当前页面是否被允许嵌入到 iframe 中，否则持续 reload 使之不可用
// 目前页面会去除服务端的 X-Frame-Allow 配置，因此需要在前端做处理
export const checkXFrameAllow = () => {
    if (!isInIframe()) {
        return;
    }
    const url = getWindowParentUrl() || '';
    // test.m.dev11.umucdn.cn ->  umucdn.cn
    const getTopDomain = (str: string) => {
        return str.split('.').slice(-2).join('');
    };
    const currentTopDomain = getTopDomain(window.location.host);
    // http://dev11.umucdn.cn/course/index#/ -> dev11.umucdn.cn
    const parentOrigin =
        url.split(/\/\/|\//).find((part) => {
            return !/http/.test(part);
        }) || '';
    const parentTopDomain = getTopDomain(parentOrigin);
    if (currentTopDomain === parentTopDomain) {
        return;
    }

    const whiteList = new RegExp(
        '://' +
            [
                '\\w*.?' + getModuleData('siteHost'),
                'vchatuat.digitalvolvo.com', // 沃尔沃小程序 sso
            ]
                .join('|')
                .replace(/[.:]/g, '\\$&'),
        'i',
    );
    if (!whiteList.test(url)) {
        console.error('Fn checkXFrameAllow denied, page will reload. Add domain to whitelist plz.');
    }
};

/**
 * @desc 将字符串中的 实体字符还原为半角符号
 * @param {string} str
 */
export const unescapeStr = (str: string = '') => {
    return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
};

/**
 * 注册用户umu_id > 0
 * 微信授权用户的student_id > 0
 * 微信授权用户不一定是注册用户
 * */
export const checkLogin = (userInfo: IUserInfo) => {
    const isLogin = userInfo && parseInt(userInfo.umu_id, 10) > 0;
    return isLogin;
};

/**
 * 取当前页面启动来源
 * */
export function getPageStartFrom() {
    return getQueryString('startfrom');
}

/**
 * 当前页面启动来源是否为直播
 * */
export function isFromLive() {
    // url 中带参数时以 url 中的为准
    const result = getPageStartFrom() === 'live';
    if (result) {
        sessionStorageHelper.set('_isFromLive', '1');
    }
    const isLastPageFromLive = sessionStorageHelper.get('_isFromLive') === '1';
    return result || isLastPageFromLive;
}
type TMiniAppEnv = 'dd' | 'wx';
/**
 * 当前页面启动来源是否为课程小程序
 */
export function isFromCourseMiniApp(): boolean | TMiniAppEnv {
    // url 中带参数时以 url 中的为准
    const isCourseMiniApp = _get(window, 'pageData.config.is_course_mini_app', false);
    if (!isCourseMiniApp) {
        return false;
    }
    if (ua.isDingding) {
        return 'dd';
    } else {
        return 'wx';
    }
}
interface IMiniAppApiOptions {
    success: (res?: any) => void;
    fail: (res?: any) => void;
    complete: (res?: any) => void;
}
/**
 * 统一钉钉和微信小程序的api
 * 需要先判断当前页面启动来源是否为课程小程序
 */
export function getMiniAppSdk() {
    const env= isFromCourseMiniApp();
    const sdkMap={
        dd:(window as any).dd as any,
        wx:(window as any).wx?.miniProgram as any
    }
   
    const envSdk=sdkMap[env as TMiniAppEnv];
    const navigateTo=(url:string,options?:IMiniAppApiOptions)=>{
        return envSdk.navigateTo({url,...(options||{})})
    }
    const postMessage=(data:any)=>{
        return envSdk.postMessage({data})
    }
    const navigateBack=(delta?:number)=>{
        return envSdk.navigateBack(delta)
    }
    const redirectTo=(url:string,options?:IMiniAppApiOptions)=>{
        return envSdk.redirectTo({url,...(options||{})})
    }
    return{
        navigateTo,
        navigateBack,
        postMessage,
        redirectTo,
    };
}

/**
 * 当前页面启动来源是否为直播
 * https://developers.weixin.qq.com/miniprogram/dev/component/web-view.html
 * https://developers.weixin.qq.com/blogdetail?action=get_post_info&docid=000488d0378078a7f926fd36456c00&highline=ios%E5%BE%AE%E4%BF%A1web-view%E7%9A%84user-agent%E7%BC%BA%E5%A4%B1miniprogram
 * */
let _isInMiniProgram: boolean;
export function isInMiniProgram(cb: (is: boolean) => void) {
    if (typeof _isInMiniProgram !== 'undefined') {
        cb && cb(_isInMiniProgram);
        return;
    }

    if (ua.isIos) {
        const wx: any = (window as any).wx; // 暂时用 any
        if (wx && wx.miniProgram && wx.miniProgram.getEnv) {
            wx.miniProgram.getEnv((res: any) => {
                _isInMiniProgram = res.miniprogram; // true
                cb && cb(_isInMiniProgram);
            });
        } else {
            _isInMiniProgram = false;
            cb && cb(_isInMiniProgram);
        }
    } else {
        _isInMiniProgram = /miniProgram/gi.test(navigator.userAgent);
        cb && cb(_isInMiniProgram);
    }
}
let isMiniProgram = false;
isInMiniProgram((is) => {
    isMiniProgram = is;
});

export { isMiniProgram };

/**
 * 将 作业里问卷的 questionList 转换成可用的结构
 * @param list 后端返回的 list
 */
export const formatHomeworkSectionList = (list: any[]): ISurveySectionInfo[] => {
    return list.map((item: any) => {
        if (item.type === ESurveySectionType.RADIO || item.type === ESurveySectionType.CHECKBOX) {
            const otherOption = item.list.filter((v: { type: EOptionType }) => v.type === EOptionType.OTHER)[0];
            if (otherOption) {
                item.extend.extra_required = otherOption.extend.setup.require;
            }
        }
        return item;
    });
};

/**
 * 将 element_stat 中 num 字段转成数字，目前后端返回的不统一
 */
export function translateStatNum<T extends Record<string, any> = Object>(stat: T) {
    Object.keys(stat).forEach((key) => {
        if (typeof stat[key] !== 'object') {
            // @ts-ignore
            stat[key] = +stat[key];
        }
    });
    return stat;
}

/**
 * 获取bos、文件下载地址
 * @param {*} imgUrl 文件url
 * @param {*} imgName 下载后文件的名字
 * @param {*} type jpg/png ...
 */
export const getDownloadUrl = (imgUrl: string, imgName: string, type?: string) => {
    // 验证发现url中带 逗号 时会失败，因此做个转化
    imgName = imgName.replace(/,/g, '_');
    if (imgName && type) {
        imgName = `${imgName}.${type}`;
    }

    if (isFromAws(imgUrl) || isFromCos(imgUrl)) {
        const link = encodeURIComponent(imgUrl);
        const name = encodeURIComponent(imgName);
        return `${$location.origin}/microapi/resourcemgt/resourcePreSign?origin_path=${link}&file_name=${name}`;
    }

    if (/\?/.test(imgUrl)) {
        return imgUrl + '&responseContentDisposition=attachment%3Bfilename%3D' + imgName;
    }

    return imgUrl + '?responseContentDisposition=attachment%3Bfilename%3D' + imgName;
};

export const downloadImgByAnchor = (url: string, fileName: string) => {
    const a: HTMLAnchorElement = document.createElement('a');
    if ('download' in a) {
        a.download = fileName;
    }
    const badA = a as HTMLAnchorElement;
    badA.href = url;
    (document.body || document.documentElement).appendChild(a);
    badA.click();
    badA.parentNode!.removeChild(a);
};

/**
 * @desc 通过 Blob 下载图片
 * @param url 图片url（百度云能下载的内种）
 * @param fileName 下载的文件名
 * @param next 回调
 */
export const downloadImgByBlob = (url: string, fileName: string, next?: () => void) => {
    const a: HTMLAnchorElement = document.createElement('a');
    const delayNext = function (delay: number) {
        setTimeout(function () {
            if (next) {
                next();
            }
        }, delay);
    };
    if ('download' in a) {
        a.download = fileName;
    }
    if (!('download' in a) && !('msSaveOrOpenBlob' in navigator)) {
        const badA = a as HTMLAnchorElement;
        badA.href = url;
        (document.body || document.documentElement).appendChild(a);
        badA.click();
        badA.parentNode!.removeChild(a);
        next && delayNext(800);
        return;
    }
    const xhr = new XMLHttpRequest();
    url += '?t=' + new Date().getTime();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    // xhr.timeout = 4000;
    // xhr.ontimeout = function() {
    //     next && next();
    // };
    xhr.onload = function () {
        if (xhr.status == 200) {
            if ('msSaveOrOpenBlob' in navigator) {
                // @ts-ignore
                window.navigator.msSaveOrOpenBlob(xhr.response, fileName);
            } else {
                const objectURL = window.URL.createObjectURL(xhr.response);
                a.href = objectURL;
                (document.body || document.documentElement).appendChild(a);
                a.click();
                a.parentNode!.removeChild(a);
            }
        }
        next && delayNext(600);
    };
    xhr.send();
};

// 下载二维码
export const downloadQr = (qrImgSrc: string) => {
    if (!qrImgSrc) {
        return;
    }
    const url = '/ajax/qrcode/downloadshare?download_qrurl=' + encodeURIComponent(qrImgSrc);
    window.open(url);
};

/**
 * @desc 秒 -> 时分秒
 * @param {number} s
 * @return {hours,minutes,seconds}
 */
export function getDurationObj(s: number) {
    s = s || 0;
    const seconds = Math.round(s % 60 || 0);
    const hours = Math.floor(s / 3600) || 0;
    const minutes = Math.round((s - hours * 3600 - seconds) / 60) || '0';
    return {
        hours: hours > 9 ? hours : '0' + hours,
        minutes: minutes > 9 ? minutes : '0' + minutes,
        seconds: seconds > 9 ? seconds : '0' + seconds,
    };
}

// 货币符 - 按站点区分
export const getCurrencySymbol = () => {
    const currentSystem = getCurrentSystem();
    const currencySymbolMap = {
        EN: '$',
        EM: '$',
        JP: 'JPY￥',
        TW: 'NT$',
        CN: '￥',
    };

    return currencySymbolMap[currentSystem as keyof typeof currencySymbolMap] || currencySymbolMap.CN;
};

export const crrencySymbol = getCurrencySymbol();

const SYMBOL_MAP: { [prop: string]: string } = {
    CNY: '￥',
    USD: '$',
    JPY: 'JPY￥',
    TWD: 'NT$',
};

export const getLocalSymbol = (symbol: string) => {
    return SYMBOL_MAP[symbol];
};

// 货币尾缀 - 按站点区分
export const getCurrencySuffix = () => {
    const currentSystem = getCurrentSystem();
    const suffixMap = {
        EN: ' USD',
        EM: ' USD',
        JP: ' JPY',
        TW: ' TWD',
        CN: commonLang('元'),
    };

    return suffixMap[currentSystem as keyof typeof suffixMap] || suffixMap.CN;
};

/**
 * 获取某一字符数量的字符串
 * @param val 字符串
 * @param limit 长度限制
 * @param arabicCharLen 非汉字系字符长度，默认为1
 */
export function getLimitCharacterStr(value: string = '', limit: number, arabicCharLen = 1) {
    const hanziLen = arabicCharLen * 2;
    let newStrLength = 0;
    if (typeof value !== 'string') {
        return '';
    }
    let len = 0;
    for (let i = 0; i < value.length; i++) {
        const str = value.charAt(i);
        if (checkStringContainChineseOrJapanese(str)) {
            len += hanziLen;
        } else {
            len += arabicCharLen;
        }
        newStrLength = i + 1;
        if (len >= limit) {
            break;
        }
    }
    return value.substr(0, newStrLength);
}

export function getCharacterLength(value: string = '', arabicCharLen = 1) {
    const hanziLen = arabicCharLen * 2;
    if (typeof value !== 'string') {
        return 0;
    }
    let len = 0;
    for (let i = 0; i < value.length; i++) {
        const str = value.charAt(i);
        if (checkStringContainChineseOrJapanese(str)) {
            len += hanziLen;
        } else {
            len += arabicCharLen;
        }
    }
    return len;
}

/**
 * @desc 数字转换为千分符
 * @param num 传入的数字
 * @return 加了千位符的字符串
 */
export function numToThousands(num: number = 0) {
    const thousandPattern = /(-?\d+)(\d{3})/;
    let formatData = num.toString();
    while (thousandPattern.test(formatData)) {
        formatData = formatData.replace(thousandPattern, '$1,$2');
    }
    return formatData;
}

export function isInPinIFrame() {
    const reg = new RegExp('\\w+.' + getModuleData('siteHost') + '/?$');
    const parentUrl = getWindowParentUrl();
    const referrerResult = reg.test(parentUrl);
    const storageKey = 'is_in_pin_i_frame';
    if (referrerResult) {
        // 设置sessionStorag以保证跳转页面后继续有效
        sessionStorageHelper.set(storageKey, '1');
        return referrerResult;
    } else {
        return sessionStorageHelper.get(storageKey);
    }
}

export function shieldAppShare() {
    if (umuWebview.UA_INFO.isUMUWebview && !/#share=0/.test($location.href)) {
        $location.href += '#share=0';
    }
}

export function showAppShare() {
    if (umuWebview.UA_INFO.isUMUWebview && /#share=0/.test($location.href)) {
        $location.href += $location.href.replace('#share=0', '');
    }
}

export function getPageTitle(title: string, isEnterprise?: boolean) {
    if (isEnterprise || ua.isUMUWebview) {
        return title;
    } else {
        return title + ' - ' + commonLang('UMU 互动学习平台');
    }
}

// 统计学习阶段卡片
export function getProgramCardCount(moduleNum = 0, groupNum = 0, sessionNum = 0, openModule = '1') {
    // 4个学习阶段，14门课程
    // 4门课程，14个小节
    const moduleStr = lang('{$0{0=个学习阶段,1=个学习阶段}}', moduleNum);
    const groupStr = lang('{$0{0=门课程,1=门课程}}', groupNum);
    const sessionStr = lang('{$0{0=个小节,1=个小节}}', sessionNum);

    let list = [moduleStr, groupStr];
    if (openModule == '0') {
        list = [groupStr, sessionStr];
    }
    return list.join(' ');
}

// 统计课程卡片
export function getGroupCardCount(sessionCount = 0, participate = 0) {
    let ret = '';

    const sessionCntTxt = lang('{$0{0=个小节,1=个小节}}', sessionCount);
    const participateTxt = lang('{$0{0=人参与,1=人参与}}', participate);

    ret = sessionCntTxt + ' ' + participateTxt;
    return ret;
}

export function getPinUrl() {
    //test是兼容本地调试的情况, m, pc通用一个规则
    const pinUrl = location.protocol + '//pin.' + location.host.replace(/^(test\.)?((www|m|pin)\.)?/, '');
    return pinUrl;
}

export const isUmuUrl = (url?: string) => {
    if (typeof url === 'string') {
        return /\.umu/.test(url);
    }
    return false;
};

export enum UrlFrom {
    umu = 'umu',
    circle = 'circle',
}

export const getUrlFrom = (url = '') => {
    let from = '';
    if (typeof url !== 'string') {
        return '';
    }
    if (/\/learning-circle\//.test(url)) {
        from = UrlFrom.circle;
    } else if (isUmuUrl(url)) {
        from = UrlFrom.circle;
    }
    return from;
};

export const isEnterprise = (eid?: string | number) => {
    if (typeof eid === 'string') {
        return !!eid && eid !== '0';
    }
    return !!eid && eid > 0;
};

/**
 * 题目的颜色总个数
 */
export const SECTION_COLOR_SCHEME_TOTAL = 9;

/**
 * 从url获取tenant id
 */
export const TENAND_ID = 'tenant_id';
export const getTenantIdFromUrl = (url: string) => {
    if (!url) {
        return '';
    }
    const tenandId = getQueryString(TENAND_ID, url);
    return tenandId || '';
};

/**
 * 构建 tenand_id=xxx的查询参数
 */
export const buildTenantIdQuery = (url: string) => {
    if (!url) {
        return '';
    }
    const tenandId = getTenantIdFromUrl(url);
    const query = !!tenandId ? `${TENAND_ID}=${tenandId}&` : '';
    return query;
};

/**
 * 获取实际的from_url
 * 在access-denied层次存在多层的from_url
 */
export function getFactFromUrl() {
    let fromUrl = $window.location.href;
    // 无权限页强制登录后跳转from_url
    if (/^\/access-denied\//.test($window.location.pathname)) {
        fromUrl = getQueryString('from_url') || '';
    }
    return fromUrl;
}

export const downloadByAnchor = (url: string, fileName?: string) => {
    const a: HTMLAnchorElement = document.createElement('a');
    if (fileName && 'download' in a) {
        a.download = fileName;
    }
    a.href = url;
    a.target = '_blank';
    (document.body || document.documentElement).appendChild(a);
    a.click();
    setTimeout(() => {
        a.parentNode!.removeChild(a);
    }, 2000);
};

export const downloadByIFrame = (url: string) => {
    const hiddenIFrameID = 'hiddenDownloader';
    let iframe = document.getElementById(hiddenIFrameID) as HTMLIFrameElement;
    const body = document.body || document.documentElement;
    if (iframe === null) {
        iframe = document.createElement('iframe');
        iframe.id = hiddenIFrameID;
        iframe.style.display = 'none';
        body.appendChild(iframe);
    }
    iframe.src = url;
    setTimeout(() => {
        iframe.src = '';
        body.removeChild(iframe);
    }, 20000);
};

// 微信公众号关注链接
export const WechatFollowLink =
    'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA5NTA1Nzk4MA==#wechat_redirect';

/**
 * 访问码 url
 * @param accessCode 访问吗
 * @param tenantId 企业 id
 */
export const getAccessUrl = (accessCode: string, tenantId?: string) => {
    const tenantQuery = tenantId ? `?tenant_id=${tenantId}` : '';
    const hostParts = window.location.host.split('.');
    const sitePostfix = hostParts[hostParts.length - 1];
    return `${accessCode}.umu.${sitePostfix}${tenantQuery ? tenantQuery : ''}`;
};

export const getMHost = () => {
    let hostname = $location.hostname.replace(/www\./i, '');
    if (hostname.indexOf('m.') > -1) {
        return `${$location.protocol}//${hostname}`;
    } else {
        hostname = hostname.replace('test.', '');
        return `${$location.protocol}//m.${hostname}`;
    }
};

export const getCircleIndexUrl = (id: string) => {
    if (!id) {
        return id;
    }
    return `${getMHost()}/learning-circle/${id}/index`;
};

export const formatDownloadUrl = (url: string) => {
    return url
        .replace('#', '%23')
        .replace(/,/g, '%20')
        .replace(/，/g, '%20')
        .replace(/%2C/g, '%20')
        .replace(/%EF%BC%8C/g, '%20');
};

/**
 * 是否在同一天
 * @param target {timestamp} 要比对的时间1
 * @param thatTime {timestamp} 要比对的时间2 or today
 * @returns {Boolean} true/false
 */
export const isThatDay = (target: number, thatTime?: number) => {
    const thatDate = thatTime ? new Date(thatTime) : new Date();
    const tatgetDate = new Date(target);
    return (
        thatDate.getDate() === tatgetDate.getDate() &&
        thatDate.getMonth() === tatgetDate.getMonth() &&
        thatDate.getFullYear() === tatgetDate.getFullYear()
    );
};

/**
 * 是否是用scorm的学习完成
 */
export const isEnableScormApiForCompletion = (function () {
    let enterpriseList: string[] = [];
    enterpriseList.push('1001261'); // 线下测试
    return (enterpriseId: string) => {
        return enterpriseList.some((id) => {
            return id === enterpriseId;
        });
    };
})();

export const utilprocess = (src?: string, _option?: any) => src || '';

/**
 * 发言频率控制
 * @param value
 * @param tag
 * @returns
 */
export function postThrottle(value: string, tag: string = '') {
    if ($window.location.href.indexOf('debugger=1') !== -1) {
        return true;
    }
    const lastPost = sessionStorageHelper.get(`${STORAGE_KEY.COMMENT_POST_VALUE}_${tag}`);
    if (value === lastPost) {
        Toast.show(lang('请不要提交重复的发言'));
        return false;
    }
    const lastPostTime = Number(sessionStorageHelper.get(STORAGE_KEY.COMMENT_POST_LAST_TIME));
    const postInterval = 10 * 1000;
    const time = new Date().getTime();
    if (time - lastPostTime < postInterval) {
        Toast.show(lang('你的手速太快了，请稍候再发'));
        return false;
    }

    sessionStorageHelper.set(`${STORAGE_KEY.COMMENT_POST_VALUE}_${tag}`, value);
    sessionStorageHelper.set(STORAGE_KEY.COMMENT_POST_LAST_TIME, String(time));
    return true;
}

export const getStaticDomain = () => {
    const currentSystem = getCurrentSystem();
    if (currentSystem === 'EN') {
        return 'https://statics00.umustatic.com';
    } else if (currentSystem === 'JP') {
        return 'https://statics22.umustatic.com';
    } else if (currentSystem === 'TW') {
        return 'https://statics11.umustatic.com';
    } else if (currentSystem === 'EM') {
        return 'https://cdn.umu.io';
    }

    return 'https://statics-umu-cn.umucdn.cn';
};

export const getCDNDomain = () => {
    const currentSystem = getCurrentSystem();
    if (currentSystem === 'CN') {
        return 'https://statics-cdn-cn.umucdn.cn';
    }

    return 'https://cdn.umustatic.com';
};

export const getIOSAppDownloadUrl = (_isEnterprise: boolean) => {
    let downloadLink = ' https://itunes.apple.com/us/app/umu/id1000568073';
    const currentSystem = getCurrentSystem();

    if (currentSystem === 'CN') {
        downloadLink = 'https://itunes.apple.com/us/app/umu互动/id949828272';
    }
    if (currentSystem === 'JP') {
        downloadLink = 'https://itunes.apple.com/us/app/umu活動/id1054359688';
    }
    if (currentSystem === 'TW') {
        downloadLink = 'https://itunes.apple.com/us/app/umu互動/id1028909355';
    }

    return downloadLink;
};

export const getAndroidAppDownloadUrl = (_isEnterprise: boolean) => {
    let downloadLink = 'https://play.google.com/store/apps/details?id=com.tc.umu';
    const currentSystem = getCurrentSystem();

    if (currentSystem === 'CN') {
        downloadLink = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.tc.umu';
    }
    if (currentSystem === 'JP') {
        downloadLink = 'https://play.google.com/store/apps/details?id=co.tc.umu';
    }
    if (currentSystem === 'TW') {
        downloadLink = 'https://play.google.com/store/apps/details?id=tw.tc.umu';
    }

    return downloadLink;
};

export const upgradeUMUApp = (isEnterprise: boolean) => {
    let downloadLink = '';
    if (ua.isIos) {
        downloadLink = getIOSAppDownloadUrl(isEnterprise);
        openWindow(downloadLink, '_self');
    } else {
        downloadLink = getAndroidAppDownloadUrl(isEnterprise);
        if (ua.isInApp()) {
            const type = SendMsgType.redirectByNative;
            sendMsgToApp(type, {
                type,
                url: downloadLink,
            });
            return;
        }
        openWindow(downloadLink, '_self');
    }
};

export * from './fontSize';
